function appBannerModalDirective () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/app-banner-modal/app-banner-modal.html?$$REVISION$$'
  }
}

export { appBannerModalDirective }
